import { render, staticRenderFns } from "./UpdateRemark.vue?vue&type=template&id=2ef03039&scoped=true"
import script from "./UpdateRemark.vue?vue&type=script&lang=js"
export * from "./UpdateRemark.vue?vue&type=script&lang=js"
import style0 from "./UpdateRemark.vue?vue&type=style&index=0&id=2ef03039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef03039",
  null
  
)

export default component.exports